import { render, staticRenderFns } from "./UploadFileCard.vue?vue&type=template&id=280d0b5e&scoped=true"
import script from "./UploadFileCard.vue?vue&type=script&lang=js"
export * from "./UploadFileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d0b5e",
  null
  
)

export default component.exports